
export default {
  name: "SectionHomepage",
  components: {},
  props: {
    data: {
      required: true,
      type: Object,
      default: function () {
        return {
          backgroundImage: "",
        };
      },
    },
    orderNo: {
      required: true,
      type: Number,
      default: 0,
    },
    hash: {
      required: true,
      type: String,
      default: "",
    },
  },
  computed: {
    backgroundUrl() {
      return this.data.backgroundImage;
    },
    activeProject() {
      return this.$store.getters.getActiveProjectData;
    },
  },
  methods: {
    resourceUrl(url) {
      if (url.includes("://")) {
        return url;
      }
      return `${this.$store.getters.cdnBase}/${url}`;
    },
  },
  mounted() {
    window.addEventListener("resize", this.resizeListener);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeListener);
  },
};
